import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import { useTenancy } from "../../../../services/tenancy";
import { useRoles } from "../../../../services/roles";
import { flatGroups } from "../../../../helpers/groups";
export default function GroupColumn({ ticket, type }) {
    var _a, _b, _c;
    const tenancy = useTenancy();
    const roles = useRoles();
    const navigate = useNavigate();
    const groups = type === "information" && ticket.groups
        ? ticket.groups
        : type === "details" && ticket.ticket_detail && ticket.ticket_detail.groups
            ? ticket.ticket_detail.groups
            : [...((_a = ticket.groups) !== null && _a !== void 0 ? _a : []), ...((_c = (_b = ticket.ticket_detail) === null || _b === void 0 ? void 0 : _b.groups) !== null && _c !== void 0 ? _c : [])];
    return (_jsx(Fragment, { children: groups.length > 0 &&
            groups.map(group => {
                let parents = [];
                if (group.parent_groups && !roles.isAgent) {
                    parents = flatGroups(new Array(group.parent_groups), 0, parents).reverse();
                }
                return (_jsx(Tooltip, Object.assign({ disableFocusListener: parents.length < 1, disableHoverListener: parents.length < 1, disableTouchListener: parents.length < 1, placement: "top", title: parents.map((parent, index) => index !== parents.length - 1 ? parent.name + " › " : parent.name) }, { children: _jsx(Chip, { label: group.name, size: "small", variant: "outlined", onClick: () => {
                            navigate(tenancy.link("/campaigns/" +
                                ticket.campaign.id +
                                "/groups/" +
                                group.id));
                        }, style: {
                            marginTop: "4px",
                            marginBottom: "4px",
                            marginRight: "8px",
                            wordBreak: "break-word",
                        } }, group.id) }), group.id));
            }) }));
}
